import { Form } from "react-bootstrap";
import BreadcrumbCRM from "../crm/BreadcrumbCRM";
import { Col, Row, Button, InputGroup, Alert } from "react-bootstrap";
import { useState, useEffect } from "react";
import { getNotas, deleteNota } from "../../services/CRMService";
import MaoTable from "../common/MaoTable";
import { useNavigate } from "react-router-dom";
import { getFechaInicioMes } from "../../utils/DateUtils";
import { useParams } from "react-router-dom";
import { getCliente } from "../../services/ClientesService";

export default function NotasCliente() {

    const params = useParams()
    const {id} = params
    const [notas, setNotas] = useState([])
    const [error, setError] = useState("")
    const [fechaDesde, setFechaDesde] = useState(getFechaInicioMes());
    const [nombreCliente, setNombreCliente] = useState("")
    const navigate = useNavigate()

    const handleFechaDesdeChange = (e) => {
        e.preventDefault();
        setFechaDesde(e.target.value);
    };

    async function recuperarNotas() {
        let idParam = id
        let inactivosParam = document.getElementById("chkIncluirInactivas").checked;
        let fechaDesdeParam = document.getElementById("txtFechaDesde").value;
        let resp = await getNotas(idParam, fechaDesdeParam, inactivosParam);
        const cliente = await getCliente(id)
        if (resp.error) {
            setError(resp.message);
            setNotas([]);
        } else {
            setError("");
            setNotas(resp.data.data);
            setNombreCliente(cliente.data.nombre_razon_social)
        }
    }

    useEffect(() => {
        recuperarNotas();
    }, [])

    function nuevo() {
        navigate("/crm/nuevanota/"+id);
    }

    async function editar(nota_id) {
        navigate("/crm/notas/"+id+"/"+nota_id);
    }

    function volver() {
        navigate("/crm")
    }

    async function borrar(nota_id) {
        try {
            if (window.confirm(`¿Esta seguro que quiere borrar la nota?`)) {
                const resp = await deleteNota(nota_id);
                if (resp.error) {
                    alert(resp.message);
                } else {
                    alert("Nota borrada correctamente");
                    recuperarNotas();
                }
            }
        } catch (error) {
            console.error(error);
            return error;
        }
    }
    
    const columnas = [
        {
            titulo:"Fecha",
            atributo:"fecha",
            className:"text-truncate "
        },{
            titulo:"Descripción",
            atributo:"descripcion",
            className : "text-justify overflow-auto"
        },{
            titulo:"Estado",
            atributo:"estado"
        }
    ]

    return <>
        <BreadcrumbCRM active="Notas de Cliente - Consulta"/>
        <Form>
            <Row className="align-items-center">
                <Col xs="auto" md="4">
                    <InputGroup className="mb-2">
                    <Form.Label htmlFor="inlineFormInput" visuallyHidden>
                        Nombre
                    </Form.Label>
                    <Form.Control
                        id="txtNombre" 
                        placeholder={nombreCliente}
                        disabled
                    />
                </InputGroup>
                </Col>
                <Col xs="auto" md="4">
                    <InputGroup className="mb-2">
                        <InputGroup.Text className="btn btn-secondary" style={{width: 5+'em'}}>Desde</InputGroup.Text>
                        <Form.Control 
                            type="date" 
                            id="txtFechaDesde" 
                            value={fechaDesde} 
                            onChange={handleFechaDesdeChange}
                            placeholder="Fecha Desde..."
                        />
                    </InputGroup>
                </Col>
                <Col xs="auto" md="2">
                    <Form.Check
                        type="checkbox"
                        id="chkIncluirInactivas"
                        className="mb-1"
                        label="Incluir inactivas"
                        onClick={recuperarNotas}
                        style={{
                            marginLeft: "1px",
                            alignContent : "start",
                            textAlign : "left"
                        }}
                    />
                </Col>
                <Col xs="auto" sm="2" md="2">
                    <InputGroup className="mb-2">
                        <Button id="btnBuscar" onClick={recuperarNotas}>
                            Buscar
                        </Button>
                    </InputGroup>
                </Col>
            </Row>
            {error!==''?
                <Row>
                    <Col xs="auto">
                        <Alert variant="danger" key="danger">{error}</Alert>
                    </Col>
                </Row>:
                <></>
            }
        </Form>
        <MaoTable 
            columnas={columnas} 
            datos={notas} 
            colId="nota_id"
            colEstado="estado"
            colNombre="descripcion"
            borrar={borrar} editar={editar}>
        </MaoTable>
        <Row>
            <Col xs="auto">
                <Button id="btnNuevo" onClick={nuevo}>Nueva</Button>
            </Col>
        </Row>
    </>
}
